import { SchoolTermDto } from '@ViewModels/SchoolTermDto'
import difference_in_days from 'date-fns/differenceInDays'
import add_days from 'date-fns/addDays'
import parse from 'date-fns/parseISO'
import { ensureValueIsDate } from './DateHelpers'

export const termDuration = (term: SchoolTermDto): number => {
   const last = ensureValueIsDate(term.LastDay)
   const first = ensureValueIsDate(term.FirstDay)
   return difference_in_days(last, first)
}

export const lastDayOfYear = (terms: SchoolTermDto[]): Date => {
   return terms
      .map(t => ensureValueIsDate(t.LastDay))
      .sort((a: Date, b: Date) => (a > b ? 1 : a < b ? -1 : 0)).last
}

export const firstDayOfYear = (terms: SchoolTermDto[]): Date => {
   return terms
      .map(t => ensureValueIsDate(t.LastDay))
      .sort((a: Date, b: Date) => (a > b ? 1 : a < b ? -1 : 0)).first
}

export const lastAvailableDayOfSchoolYear = (start: Date | string): Date => {
   const startDate = ensureValueIsDate(start)
   return add_days(startDate, 364)
}

export const addDays = (date: Date, days: number): Date => {
   return add_days(date, days)
}

export const createTerm = (start: Date, existingTerms: SchoolTermDto[]) => {
   // Any new term we create have to fit within the school year
   //
   // If there are no school terms yet, we creat the first term with
   //  - start date being the first day of the school year
   //  - end date being 60 days later
   //
   // If there are already terms, we try to create one two weeks after the last existing one
   //
   // Assumption, a new term cannot be added when the max last day is the last possible day of the school year
   // If we do not have a school term already:
   //  create a new term with
   //      the start date = the the start date of the school for the year
   //      the end date = to the start date + 2 months
   // else
   //  get the max end date from the current terms
   //  create a new term with
   //      the start date = the the start date of the school for the year
   //
   const end = lastAvailableDayOfSchoolYear(start)
   const lastDayOfTerms = lastDayOfYear(existingTerms)

   let firstDay = start

   if (existingTerms.length > 0) {
      firstDay = addDays(lastDayOfTerms, 17)

      if (firstDay > end) {
         firstDay = addDays(lastDayOfTerms, 3)
      }
   }

   let lastDay = addDays(firstDay, 60)

   if (lastDay > end) {
      lastDay = end
   }

   const schoolTerm = {
      FirstDay: firstDay,
      LastDay: lastDay,
      IsEnabled: true,
   } as SchoolTermDto

   return schoolTerm
}
